/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material'
import { useSelector } from 'react-redux'
import { Chip, Alert, Fab } from '@mui/material'
import { GUIA_ERP_LIST_RECIBIDO_BY_ID_CLI } from '../../Constants/ApiConstants'
import InfoIcon from '@mui/icons-material/Info'
import '../../Styles/App/Apartado/Apartado.css'
import requests from '../../Components/AxiosCalls/AxiosCall'
import DownloadIcon from '@mui/icons-material/Download'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'

const EnviosRecibidos = (props) => {
	const [_GuiasEnvio, setGuiasEnvio] = useState([])
	const [_Descarga, setDescarga] = useState()

	const userLogin = useSelector((state) => state.userLogin)
	const { loading, error, userInfo } = userLogin

	const [_Ocultar, setOcultar] = useState(true)
	const [_Ocultar2, setOcultar2] = useState(true)

	const getGuiasEnvio = () => {
		props.setOpenLoadingScreen()
		requests
			.get(GUIA_ERP_LIST_RECIBIDO_BY_ID_CLI, userInfo.intIdUsuario)
			.then((response) => {
				setGuiasEnvio(response)

				if (response.length > 0) {
					setOcultar(false)
					setOcultar2(true)
				} else {
					setOcultar(true)
					setOcultar2(false)
				}
				props.setCloseLoadingScreen()
				setDescarga(null)
			})
			.catch((error) => {
				console.log('Error: ' + error)
				props.setCloseLoadingScreen()
			})
	}

	useEffect(() => {
		getGuiasEnvio()
	}, [])

	return (
		<div>
			<div className='containerViewUser'>
				<div className='flex-start w100'>
					<Chip
						icon={<LocalShippingIcon />}
						label='Envios/ Recibidos.'
						color='primary'
						className='back-transparent font-letter font-barter font-20'
					/>
				</div>

				<div className='box-consigna-pro' hidden={_Ocultar}>
					{_GuiasEnvio.map((row, index) => (
						<div className='box-list-consigna-pro' key={row.lngIdGuiaBr}>
							<div className='flex-column-start-between w80 pl1'>
								<div className='w100'>
									<div className='flex-between'>
										<span className='p20 bold upperCase'></span>
										<span className='p co-grey'>
											<Button
												className='btn-calendar'
												startIcon={<DownloadIcon />}
												onClick={function () {
													window.open(row.txtUrlGuia, '_blank')
												}}
											>
												Descargar guía
											</Button>
										</span>
									</div>
									<span className='p '>Fecha de envío: {row.fecEnvio}</span>
									<br />
									<span className='p '>
										Fecha de llegada:{' '}
										{row.fecLlegada === '01/01/0001'
											? 'Sin fecha'
											: row.fecLlegada}
									</span>
									<br />
									<span className='p '>SKU del producto: {row.txtSkuReg}</span>
									<br />
									<span className='p '>Guía de envio: {row.txtGuiaBr}</span>
									<br />
									<span className='p '>
										Observaciones: {row.txtObservaciones}
									</span>
									<br />
									<span className='p '>
										Estatus del envío: {row.txtStatusEnvio}
									</span>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
			<div hidden={_Ocultar2}>
				<div className='containerViewUser'>
					<Alert
						className='alert-no-data'
						icon={
							<InfoIcon fontSize='inherit' className='alert-icon-no-data' />
						}
					>
						Aún no cuentas con envíos recibidos.
					</Alert>
				</div>
			</div>
		</div>
	)
}
export default EnviosRecibidos
